/*
 * Overlook Boots: Spanish (/es) labels for the Boost filter.
 * Loaded only when request.locale is "es" (see snippets/boost-pfs.liquid).
 * Changes display text only. Filter values, URL params and the English storefront are untouched.
 * To add a term: put the English text (lowercase, without the tag prefix) and the Spanish in the right list.
 */
(function () {
  if (typeof Shopify === 'undefined' || Shopify.locale !== 'es') return;
  if (typeof BoostPFS === 'undefined') return;
  var B = {};
  try { BoostPFS.inject(B); } catch (e) { return; }
  var FilterOption = B.FilterOption, FilterOptionItem = B.FilterOptionItem, FilterRefineByItem = B.FilterRefineByItem;

  // Filter titles, by Boost option id, then by English title as a fallback.
  var TITLES = {
    pf_t_toe_type: 'Tipo de punta',
    pf_t_category: 'Categoría',
    pf_t_feature: 'Características',
    pf_v_vendor: 'Marca',
    pf_opt_size: 'Talla',
    pf_opt_width: 'Ancho',
    pf_opt_color: 'Color',
    pf_t_insulation: 'Aislamiento térmico',
    pf_t_safety_compliance: 'Normas de seguridad',
    pf_p_price: 'Precio',
    pf_pt_product_type: 'Tipo de producto'
  };
  var TITLES_BY_LABEL = {
    'toe type': 'Tipo de punta',
    'category': 'Categoría',
    'feature': 'Características',
    'features': 'Características',
    'vendor': 'Marca',
    'brand': 'Marca',
    'size': 'Talla',
    'width': 'Ancho',
    'color': 'Color',
    'insulation': 'Aislamiento térmico',
    'safety compliance': 'Normas de seguridad',
    'price': 'Precio',
    'product type': 'Tipo de producto'
  };

  // Filter values, by English display text (lowercase, tag prefix removed).
  var COMMON = {
    // Toe type
    'all safety toe': 'Todas las puntas de seguridad',
    'alloy toe': 'Punta de aleación',
    'carbon toe': 'Punta de carbono',
    'composite toe': 'Punta compuesta',
    'soft toe': 'Punta suave',
    'steel toe': 'Punta de acero',
    // Boot categories
    '6 inch': '6 pulgadas',
    '8 inch': '8 pulgadas',
    'athletic work shoes': 'Zapatos de trabajo deportivos',
    'fire': 'Bomberos',
    'hiker': 'Tipo hiker',
    'made in the usa': 'Hechas en EE. UU.',
    'military': 'Militares',
    'oilfield': 'Petróleo y gas',
    'rubber boots': 'Botas de hule',
    'western work': 'Vaqueras de trabajo',
    'work shoes': 'Zapatos de trabajo',
    // Apparel categories
    'bib': 'Overoles de peto',
    'flannel': 'Franela',
    'fleece': 'Polar',
    'jacket': 'Chamarras',
    'long sleeve t-shirt': 'Camisetas de manga larga',
    'pants': 'Pantalones',
    't-shirt': 'Camisetas',
    // Features
    'electric hazard': 'Riesgo eléctrico (EH)',
    'metguard': 'Protección metatarsal',
    'moc toe': 'Punta moc',
    'puncture resistant': 'Resistente a perforaciones',
    'side zip': 'Cierre lateral',
    'slip resistant': 'Antideslizante',
    'square toe': 'Punta cuadrada',
    'round toe': 'Punta redonda',
    'waterproof': 'Impermeable',
    'wedge sole': 'Suela de cuña',
    'flame resistant': 'Resistente al fuego (FR)',
    'high-visibility': 'Alta visibilidad',
    'moisture wicking': 'Absorbe la humedad',
    'odor resistant': 'Antiolor',
    'water-repellent': 'Repelente al agua',
    // Insulation
    'all insulated': 'Todas con aislamiento',
    '200g - 400g': '200 g - 400 g',
    '600g - 800g': '600 g - 800 g',
    '1000g+': '1000 g o más',
    // Product type
    'accessories': 'Accesorios',
    'apparel': 'Ropa',
    'boots': 'Botas',
    'coveralls': 'Overoles completos',
    'eye protection': 'Protección para los ojos',
    'gift card': 'Tarjeta de regalo',
    'hand protection': 'Protección para las manos',
    'head protection': 'Protección para la cabeza',
    'jackets': 'Chamarras',
    'overalls': 'Overoles de peto',
    'safety vests': 'Chalecos de seguridad',
    'shirts': 'Camisas',
    'shoes': 'Zapatos',
    'sweatshirts': 'Sudaderas',
    't-shirts': 'Camisetas'
  };
  var BY_OPTION = {
    pf_opt_width: {
      'narrow': 'Angosto',
      'medium': 'Medio',
      'wide': 'Ancho',
      'extra wide': 'Extra ancho',
      '2x extra wide': 'Doble extra ancho'
    },
    // Plain colors only; coined color names (Tobacco, Wheat, Coyote...) stay English.
    pf_opt_color: {
      'black': 'Negro',
      'blue / navy': 'Azul / Azul marino',
      'brown': 'Café',
      'camo': 'Camuflaje',
      'green / olive': 'Verde / Verde olivo',
      'green': 'Verde',
      'grey': 'Gris',
      'gray': 'Gris',
      'heather grey': 'Gris jaspeado',
      'medium gray': 'Gris medio',
      'charcoal heather': 'Carbón jaspeado',
      'khaki': 'Caqui',
      'khaki heather': 'Caqui jaspeado',
      'golden brown': 'Café dorado',
      'orange': 'Naranja',
      'red': 'Rojo',
      'red heather': 'Rojo jaspeado',
      'royal blue': 'Azul rey',
      'white': 'Blanco',
      'yellow': 'Amarillo',
      'hi vis yellow': 'Amarillo alta visibilidad'
    }
  };
  // Never translated: brand names, sizes, safety codes.
  var SKIP = { pf_v_vendor: 1, pf_opt_size: 1, pf_t_safety_compliance: 1 };

  // Generic filter labels.
  var UI = {
    refine: 'Filtrar productos',
    refineMobile: 'Filtrar productos',
    refineMobileCollapse: 'Ocultar filtros',
    refineDesktop: 'Filtrar',
    refineDesktopCollapse: 'Ocultar filtros',
    clear: 'Borrar',
    clearAll: 'Borrar todo',
    apply: 'Aplicar',
    applyAll: 'Aplicar todo',
    close: 'Cerrar',
    back: 'Atrás',
    viewMore: 'Ver más',
    viewLess: 'Ver menos',
    under: 'Menos de',
    above: 'Más de',
    ratingStar: 'estrella',
    ratingStars: 'estrellas',
    ratingUp: 'o más',
    showResult: 'Ver resultados',
    showLimit: 'Mostrar',
    searchOptions: 'Buscar opciones',
    sorting: 'Ordenar por',
    listView: 'Vista de lista',
    gridView: 'Vista de cuadrícula',
    gridViewColumns: 'Cuadrícula de {{ count }} columnas',
    loadMore: 'Cargar {{ amountProduct }} productos más',
    loadMoreTotal: '{{ from }} - {{ to }} de {{ total }} productos',
    loadPreviousPage: 'Cargar página anterior',
    inCollectionSearch: 'Buscar productos en esta colección',
    // Same wording as the collection page sort labels (sections/main-collection.liquid); used where a page has none.
    sortByOptions: {
      'relevance': 'Relevancia',
      'best-selling': 'Más vendidos',
      'manual': 'Destacados',
      'price-ascending': 'Precio: menor a mayor',
      'price-descending': 'Precio: mayor a menor',
      'title-ascending': 'Nombre: A-Z',
      'title-descending': 'Nombre: Z-A',
      'created-ascending': 'Más antiguos primero',
      'created-descending': 'Más recientes primero'
    }
  };

  function norm(s) { return String(s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }

  function translateValue(optionId, text) {
    if (typeof text !== 'string' || !text || SKIP[optionId]) return text;
    var key = norm(text);
    var own = BY_OPTION[optionId];
    if (own && own.hasOwnProperty(key)) return own[key];
    if (COMMON.hasOwnProperty(key)) return COMMON[key];
    return text;
  }

  function translateTitle(option) {
    if (!option) return;
    var id = option.filterOptionId;
    if (TITLES.hasOwnProperty(id)) { option.label = TITLES[id]; return; }
    var key = norm(option.label);
    if (TITLES_BY_LABEL.hasOwnProperty(key)) option.label = TITLES_BY_LABEL[key];
  }

  // 1) Generic labels: merged by Boost's Settings.init (runs later, in boost-pfs-init.js).
  try {
    if (typeof boostPFSThemeConfig !== 'undefined') {
      boostPFSThemeConfig.labelTranslations = boostPFSThemeConfig.labelTranslations || {};
      var es = boostPFSThemeConfig.labelTranslations.es = boostPFSThemeConfig.labelTranslations.es || {};
      for (var k in UI) if (UI.hasOwnProperty(k) && !es.hasOwnProperty(k)) es[k] = UI[k];
    }
  } catch (e) {}

  // 2) Filter titles: translate the option's display label after Boost sets its data.
  try {
    if (FilterOption && FilterOption.prototype.setData) {
      var origOptionSetData = FilterOption.prototype.setData;
      FilterOption.prototype.setData = function () {
        var out = origOptionSetData.apply(this, arguments);
        try { translateTitle(this); } catch (e) {}
        return out;
      };
    }
  } catch (e) {}

  // 3) Filter values: translate the displayed label only; the value used for filtering stays English.
  try {
    if (typeof FilterOptionItem !== 'undefined' && FilterOptionItem.prototype.buildLabel) {
      var origItemLabel = FilterOptionItem.prototype.buildLabel;
      FilterOptionItem.prototype.buildLabel = function () {
        var out = origItemLabel.apply(this, arguments);
        try {
          var opt = this.filterOption ? this.filterOption : this.parent;
          return translateValue(opt && opt.filterOptionId, out);
        } catch (e) { return out; }
      };
    }
    if (typeof FilterRefineByItem !== 'undefined' && FilterRefineByItem.prototype.buildLabel) {
      var origRefineLabel = FilterRefineByItem.prototype.buildLabel;
      FilterRefineByItem.prototype.buildLabel = function () {
        var out = origRefineLabel.apply(this, arguments);
        try {
          var opt = this.filterOption || {};
          var text = out;
          if (typeof opt.prefix === 'string' && opt.prefix && typeof text === 'string' && text.indexOf(opt.prefix) === 0) {
            text = text.slice(opt.prefix.length);
          }
          var t = translateValue(this.filterOptionId || opt.filterOptionId, text);
          return t === text ? out : t;
        } catch (e) { return out; }
      };
    }
  } catch (e) {}
})();
